import { CheckIcon, MinusIcon } from '@heroicons/react/24/outline';

interface ChecklistItem {
  id: string;
  text: string;
  completed?: boolean;
}

interface ChecklistSectionProps {
  title: string;
  description: string;
  items: ChecklistItem[];
}

export default function ChecklistSection({ title, description, items }: ChecklistSectionProps) {
  return (
    <div className="bg-gray-50 p-4 rounded-lg">
      <h4 className="font-medium">{title}</h4>
      <p className="text-sm text-gray-600 mt-1">{description}</p>
      <ul className="mt-3 space-y-2">
        {items.map((item) => (
          <li key={item.id} className="flex items-start space-x-3">
            <span className="flex-shrink-0 h-5 w-5 flex items-center justify-center">
              {item.completed ? (
                <CheckIcon className="h-4 w-4 text-green-500" />
              ) : (
                <MinusIcon className="h-4 w-4 text-gray-400" />
              )}
            </span>
            <span className="text-sm text-gray-600">{item.text}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}